import React from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'

import GMSPage from "../pages/GMS";
import { AuthContext } from "../contexts/AuthContext";
import LoginPage from "../pages/Login";
import { PATHS } from './constant';
import BuySellPage from '../pages/BuySell';
import BuyBackPage from '../pages/BuyBack';
import PurityTestingPage from '../pages/PurityTesting';
import JobWorkPage from '../pages/JobWork';
import MintedSalesPage from '../pages/MintedSales';
import PvcTransactionPage from '../pages/PvcTransaction';
import CreateTransactionPage from '../pages/CreateTransaction';
import CustomerSetupPage from '../pages/CustomerSetup';
import PaymentBlotterPage from '../pages/PaymentBlotter';
import BillingBlotterPage from '../pages/BillingBlotter';
import DeliveryBlotterPage from '../pages/DeliveryBlotterPage';
import InboundBlotterPage from '../pages/InboundBlutter';
import PhysicalBlotterPage from '../pages/PhysicalBlotter';
import TradeBlotterPage from '../pages/TradeBlotterPage';
import TransferBlotterPage from '../pages/TransferBlotterPage';
import InventoryRequestPage from '../pages/InventoryRequest';
import InventoryPage from '../pages/Inventory';
import TransferOrderPage from '../pages/TransferOrder';
import ReportsPage from '../pages/Reports';
import CustomersPage from '../pages/Customers';
import { getUserPrivilages } from './helpers';
import InventoryManagementPage from '../pages/InventoryManagement';
import useInactivityLogout from '../hooks/userInactivityLogout';
import GetReports from '../pages/GetPvcReport'
import EmployeesPage from '../pages/Employees';
import RedeemAtPVC from '../pages/RedeemAtPVC';
import RedeemAtPVCTransaction from '../pages/RedeemAtPVCTransaction';
export interface IRoutes {
    path: string;
    component: (props: any) => React.JSX.Element;
    redirect?: {
        condition?: boolean;
        path: string;
    };
}

export const ROUTES = (): IRoutes[] => {

    const { authState, user } = React.useContext(AuthContext);

    const privilages = getUserPrivilages(user)

    return [
        {
            path: PATHS.GMS,
            component: GMSPage,
            redirect: {
                condition: !authState?.sessionId || !privilages.gms.write,
                path: "/login",
            },
        },
        {
            path: PATHS.GMS + '/:id',
            component: GMSPage,
            redirect: {
                condition: !authState?.sessionId || !privilages.gms.write,
                path: "/login",
            },
        },
        {
            path: PATHS.BUY_BACK,
            component: BuyBackPage,
            redirect: {
                condition: !authState?.sessionId || !privilages.buyback.write,
                path: "/login",
            },
        },
        {
            path: PATHS.BUY_BACK + '/:id',
            component: BuyBackPage,
            redirect: {
                condition: !authState?.sessionId || !privilages.buyback.write,
                path: "/login",
            },
        },
        {
            path: PATHS.BUY_SELL,
            component: BuySellPage,
            redirect: {
                condition: !authState?.sessionId || !privilages.buysell.write,
                path: "/login",
            },
        },
        {
            path: PATHS.BUY_SELL + '/:id',
            component: BuySellPage,
            redirect: {
                condition: !authState?.sessionId || !privilages.buysell.write,
                path: "/login",
            },
        },
        {
            path: PATHS.PURITY_TESTING,
            component: PurityTestingPage,
            redirect: {
                condition: !authState?.sessionId || !privilages.puritytesting.write,
                path: "/login",
            },
        },
        {
            path: PATHS.PURITY_TESTING + '/:id',
            component: PurityTestingPage,
            redirect: {
                condition: !authState?.sessionId || !privilages.puritytesting.write,
                path: "/login",
            },
        },
        {
            path: PATHS.JOB_WORK,
            component: JobWorkPage,
            redirect: {
                condition: !authState?.sessionId || !privilages.jobwork.write,
                path: "/login",
            },
        },
        {
            path: PATHS.JOB_WORK + '/:id',
            component: JobWorkPage,
            redirect: {
                condition: !authState?.sessionId || !privilages.jobwork.write,
                path: "/login",
            },
        },
        {
            path: PATHS.MINTED_SALES,
            component: MintedSalesPage,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.MINTED_SALES + '/:id',
            component: MintedSalesPage,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.DASHBOARD,
            component: CreateTransactionPage,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.CREATE_TRANSACTION,
            component: CreateTransactionPage,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.LOGIN,
            component: LoginPage,
            redirect: {
                condition: Boolean(authState?.sessionId),
                path: "/",
            },
        },
        {
            path: PATHS.PVC_TRANSACTIONS,
            component: PvcTransactionPage,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.CUSTOMERS,
            component: CustomersPage,
            redirect: {
                condition: !authState?.sessionId || !privilages.customer.read,
                path: "/login",
            },
        },
        {
            path: PATHS.CUSTOMER_SETUP + '/:id',
            component: CustomerSetupPage,
            redirect: {
                condition: !authState?.sessionId || !privilages.customer.write,
                path: "/login",
            },
        },
        {
            path: PATHS.CUSTOMER_SETUP,
            component: CustomerSetupPage,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.PAYMENT_BLOTTER,
            component: PaymentBlotterPage,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.BILLING_BLOTTER,
            component: BillingBlotterPage,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.DELIVERY_BLOTTER,
            component: DeliveryBlotterPage,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.INBOUND_BLOTTER,
            component: InboundBlotterPage,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.PHYSICAL_BLOTTER,
            component: PhysicalBlotterPage,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.TRADE_BLOTTER,
            component: TradeBlotterPage,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.TRANSFERS_BLOTTER,
            component: TransferBlotterPage,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.INVENTORY_REQUEST,
            component: InventoryRequestPage,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.INVENTORY,
            component: InventoryPage,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.TRANSFER_ORDER,
            component: TransferOrderPage,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        // {
        //     path: PATHS.USER_MASTER,
        //     component: UserMasterPage,
        //     redirect: {
        //         condition: !authState?.sessionId,
        //         path: "/login",
        //     },
        // },
        {
            path: PATHS.REPORTS,
            component: ReportsPage,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.TRANSACTIONALREPORT,
            component: GetReports,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.STOCKAGEINGREPORT,
            component: GetReports,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.PAYMANTSREPORT,
            component: GetReports,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.STOCKORDERSREPORT,
            component: GetReports,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.INVENTORYONHANDREPORT,
            component: GetReports,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.STOCKINREPORT,
            component: GetReports,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.STOCKOUTREPORT,
            component: GetReports,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.DOCUMENTREPORT,
            component: GetReports,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.SALESREPORT,
            component: GetReports,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.STOCKREPORT,
            component: GetReports,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.SKYCREPORT,
            component: GetReports,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.INVENTORY_MANAGEMENT,
            component: InventoryManagementPage,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },
        {
            path: PATHS.EMPLOYEES,
            component: EmployeesPage,
            redirect: {
                condition: !authState?.sessionId || !privilages.customer.read,
                path: "/login",
            },
        },
        {
            path: PATHS.REDEEM_AT_PVC,
            component: RedeemAtPVC,
            redirect: {
                condition: !authState?.sessionId || !privilages.customer.read, 
                path: "/login",
            },
        },
        {
            path: PATHS.REDEEM_AT_PVC_TRANSACTION,
            component: RedeemAtPVCTransaction,
            redirect: {
                condition: !authState?.sessionId || !privilages.customer.read,
                path: "/login",
            },
        },
          {
            path: PATHS.REDEEM_AT_PVC + '/:id',
            component: RedeemAtPVC,
            redirect: {
                condition: !authState?.sessionId,
                path: "/login",
            },
        },

    ];
};


const AllRoutes = () => {
    useInactivityLogout()
    return (
        < Routes >
            {ROUTES().map((route: IRoutes, index: number) => {
                return <Route
                    key={index}
                    path={route.path}
                    element={
                        route.redirect?.condition ?
                            <Navigate to={route?.redirect?.path!} /> :
                            <route.component />
                    }
                />
            })}
        </Routes >
    )
}

export default AllRoutes
